var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/ui/melodeon.html';
var html = "<div class=\"accordion-container\">\n  <dl track-feature=\"$track.features.accordion\" ng-attr-id=\"{{$melodeon.groupId}}\" class=\"accordion\" ng-transclude></dl>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;